import Fab from "@mui/material/Fab";
import PropTypes from "prop-types";

const ButtonLogin = (props) => {
  return (
    <Fab
      variant="extended"
      color="primary"
      onClick={props.handleClick}
      sx={{ width: "100%" }}
    >
      Σύνδεση
    </Fab>
  );
};

export default ButtonLogin;

ButtonLogin.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
